/* Dough Dough at Home — send book links to the reader's own Amazon store.
 *
 * Why this exists: a Kindle book CANNOT be bought from the wrong store. An Australian reader on
 * amazon.co.uk is simply blocked — Amazon makes them go to amazon.com.au. Our one Australian sale
 * so far had to find their own way there. This does that for them.
 *
 * Why it is not a blanket domain swap. Checked by hand on 18 Aug 2026:
 *     amazon.com     paperback $17.52    sold by Amazon.com      <- printed locally
 *     amazon.ca      paperback C$24.45   sold by Amazon.ca       <- printed locally
 *     amazon.com.au  paperback A$42.81   sold by Amazon Germany  <- IMPORTED, ~2x the UK price
 * KDP does not print in Australia, so swapping the print links to .com.au would quietly double the
 * price. Kindle therefore routes everywhere; print only routes where KDP actually prints, and
 * otherwise stays on .co.uk.
 *
 * Progressive enhancement: the HTML links stay .co.uk and work perfectly with JavaScript off. This
 * only ever rewrites a link it recognises by ASIN, so an Amazon link added later (the starter, say,
 * whose ASIN differs per marketplace) is left completely alone.
 *
 * No network calls, no cookies, no IP lookup — country comes from the browser's own timezone, with
 * the locale region as a fallback. Nothing is stored and nothing is sent anywhere.
 */
(function () {
  'use strict';

  // ---- which stores exist, per country ----
  var STORE = {
    GB: 'co.uk', IE: 'co.uk',              // amazon.ie carries almost no KDP print; .co.uk serves Ireland better
    US: 'com', CA: 'ca', AU: 'com.au',
    DE: 'de', FR: 'fr', ES: 'es', IT: 'it', NL: 'nl', PL: 'pl', SE: 'se', BE: 'com.be',
    JP: 'co.jp', IN: 'in', BR: 'com.br', MX: 'com.mx',
    SG: 'sg', AE: 'ae', SA: 'sa', TR: 'com.tr', EG: 'eg'
  };

  // Countries where KDP prints locally. Anything not in here keeps the .co.uk print link.
  // US/CA verified directly; DE confirmed because the Australian listing is fulfilled *from*
  // Amazon Germany; FR/ES/IT/NL/PL/SE are the rest of KDP's European print network.
  var PRINT_OK = { GB:1, US:1, CA:1, DE:1, FR:1, ES:1, IT:1, NL:1, PL:1, SE:1 };

  // ---- our books ----
  var BOOKS = {
    B0HDPWC2SM: 'ebook',   // Your First Sourdough — Kindle
    B0HDQGFRC7: 'print',   // Your First Sourdough — Paperback
    B0HDQ2ZLK2: 'print'    // Your First Sourdough — Hardcover
  };

  var TZ = {
    'Europe/London':'GB','Europe/Dublin':'IE',
    'America/New_York':'US','America/Detroit':'US','America/Chicago':'US','America/Denver':'US',
    'America/Phoenix':'US','America/Los_Angeles':'US','America/Anchorage':'US','America/Boise':'US',
    'America/Indiana/Indianapolis':'US','America/Kentucky/Louisville':'US','America/Menominee':'US',
    'America/Juneau':'US','America/Nome':'US','America/Sitka':'US','Pacific/Honolulu':'US',
    'America/Toronto':'CA','America/Vancouver':'CA','America/Edmonton':'CA','America/Winnipeg':'CA',
    'America/Halifax':'CA','America/St_Johns':'CA','America/Regina':'CA','America/Moncton':'CA',
    'America/Whitehorse':'CA','America/Yellowknife':'CA','America/Dawson_Creek':'CA','America/Iqaluit':'CA',
    'Australia/Sydney':'AU','Australia/Melbourne':'AU','Australia/Brisbane':'AU','Australia/Perth':'AU',
    'Australia/Adelaide':'AU','Australia/Hobart':'AU','Australia/Darwin':'AU','Australia/Canberra':'AU',
    'Australia/Broken_Hill':'AU','Antarctica/Macquarie':'AU',
    'Europe/Berlin':'DE','Europe/Busingen':'DE','Europe/Vienna':'DE','Europe/Zurich':'DE',
    'Europe/Paris':'FR','Europe/Monaco':'FR',
    'Europe/Madrid':'ES','Atlantic/Canary':'ES','Africa/Ceuta':'ES',
    'Europe/Rome':'IT','Europe/Amsterdam':'NL','Europe/Warsaw':'PL','Europe/Stockholm':'SE',
    'Europe/Brussels':'BE','Asia/Tokyo':'JP','Asia/Kolkata':'IN','Asia/Calcutta':'IN',
    'America/Sao_Paulo':'BR','America/Bahia':'BR','America/Fortaleza':'BR','America/Recife':'BR',
    'America/Manaus':'BR','America/Mexico_City':'MX','America/Monterrey':'MX','America/Tijuana':'MX',
    'America/Cancun':'MX','America/Merida':'MX',
    'Asia/Singapore':'SG','Asia/Dubai':'AE','Asia/Riyadh':'SA','Europe/Istanbul':'TR','Africa/Cairo':'EG'
  };

  function detectCountry() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && TZ[tz]) return TZ[tz];
    } catch (e) { /* older browsers: fall through to locale */ }
    try {
      var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
      for (var i = 0; i < langs.length; i++) {
        var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
        if (m) {
          var cc = m[1].toUpperCase();
          if (STORE[cc]) return cc;
        }
      }
    } catch (e) { /* nothing else to try */ }
    return null;
  }

  function apply() {
    var country = detectCountry();
    if (!country || country === 'GB' || !STORE[country]) return;   // already right, or unknown
    var tld = STORE[country];
    if (tld === 'co.uk') return;

    var links = document.querySelectorAll('a[href*="amazon.co.uk/dp/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var m = /amazon\.co\.uk\/dp\/([A-Z0-9]{10})/.exec(a.getAttribute('href') || '');
      if (!m) continue;
      var asin = m[1];
      var kind = BOOKS[asin];
      if (!kind) continue;                                  // not one of ours — never touch it
      if (kind === 'print' && !PRINT_OK[country]) continue;  // would be an import at a worse price

      a.setAttribute('data-original-href', a.getAttribute('href'));
      a.setAttribute('href', a.getAttribute('href').replace('amazon.co.uk', 'amazon.' + tld));
      a.setAttribute('data-amazon-store', tld);
    }
  }

  // ---- the starter (added 25 Oct 2026) ----
  // Half our visitors read recipes from the US, Canada and Australia, and almost none of them buy here:
  // they'd pay overseas postage and wait a week. Our own SF starter listing (same ASIN in all three)
  // has Prime stock there. So for those three countries only, the starter buy buttons go to it, and the
  // SF product page gets a Prime line under Add to cart. Everyone else, the UK included, is untouched.
  // Shopify's own geolocated country comes first; the timezone guess is the fallback.
  var STARTER_ASIN = 'B0GP6WSX6S';
  var STARTER_STORE = { US: 'com', CA: 'ca', AU: 'com.au' };
  var STARTER_PATH = /\/products\/sourdough-starter-san-francisco-style/;

  function starterCountry() {
    var sc = window.Shopify && window.Shopify.country;
    if (sc) return STARTER_STORE[sc] ? sc : null;           // Shopify knows; trust it (GB stays GB)
    var c = detectCountry();
    return c && STARTER_STORE[c] ? c : null;
  }

  function applyStarter() {
    var country = starterCountry();
    if (!country) return;
    var tld = STARTER_STORE[country];
    var url = 'https://www.amazon.' + tld + '/dp/' + STARTER_ASIN;
    var label = 'Get it on Amazon.' + tld + ' with Prime →';

    // In-content buy buttons that point at the SF starter.
    var btns = document.querySelectorAll('a.dd-rp__btn, a.gd__btn, a.sf-cta__btn');
    for (var i = 0; i < btns.length; i++) {
      var a = btns[i];
      if (!STARTER_PATH.test(a.getAttribute('href') || '')) continue;
      a.setAttribute('data-original-href', a.getAttribute('href'));
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
      a.setAttribute('data-amazon-store', tld);
      a.textContent = label;
    }

    // Our add-to-basket cards (Tools page, recipe/blog cards, sticky bar, cart upsell): swap each SF
    // button for an Amazon link. Buttons for starters that aren't on Amazon carry data-no-geo.
    var tbs = document.querySelectorAll('.dd-tcta__btn:not([data-no-geo]):not([data-amazon-store])');
    for (var j = 0; j < tbs.length; j++) {
      var tb = tbs[j];
      if (tb.closest && tb.closest('m-cart-drawer, .m-cart-drawer')) continue;   // never inside the basket
      var l = document.createElement('a');
      l.className = tb.className; l.href = url; l.target = '_blank'; l.rel = 'noopener';
      l.setAttribute('data-amazon-store', tld); l.style.textDecoration = 'none';
      l.textContent = label;
      tb.parentNode.replaceChild(l, tb);
    }

    // SF product page: a Prime line under Add to cart (ordering direct still works as normal).
    if (STARTER_PATH.test(location.pathname)) {
      var buy = document.querySelector('.main-product__block-buy_buttons');
      if (buy && !document.querySelector('.dd-amz-geo')) {
        var box = document.createElement('div');
        box.className = 'dd-amz-geo';
        box.setAttribute('style', 'margin-top:14px;padding:12px 14px;background:#FBF6EA;border:1px solid #E4D9BF;border-radius:12px;color:#2C2416;line-height:1.5;font-size:15px;');
        box.innerHTML = 'Ordering from ' + (country === 'US' ? 'the USA' : country === 'CA' ? 'Canada' : 'Australia') +
          '? <a href="' + url + '" target="_blank" rel="noopener" data-amazon-store="' + tld + '" style="color:#B85C20;font-weight:700;">Get it on Amazon.' + tld +
          ' with Prime delivery →</a><br><span style="opacity:.75;font-size:14px;">It’s our own listing, shipped from a local Amazon warehouse.</span>';
        buy.parentNode.insertBefore(box, buy.nextSibling);
      }
    }
  }

  function run() {
    try { apply(); } catch (e) {}
    try { applyStarter(); } catch (e) {}
    // Some cards are added by script after load (sticky bar, cart upsell): re-run when the page grows.
    try {
      if (!starterCountry() || !window.MutationObserver) return;
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t); t = setTimeout(function () { try { applyStarter(); } catch (e) {} }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
